import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CartComponent } from './cart.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [CartComponent],
  imports: [SharedModule, FormsModule],
  exports: [CartComponent]
})
export class CartModule {}
